/**
 * order.vue的字段相关代码，字段生成，字段排序，字段过滤
 */
// import {_axios as axios} from  "../../plugins/axios.js";
import i18nKit from "../../plugins/I18N.js"
let i18n = i18nKit.methods;

import kit from "../../plugins/kit.js"
let api = kit.api;

import {dicts} from "../../plugins/dict.js";

// import Vue from 'vue'
// const h = new Vue().$createElement

/**
 * 
 * @param {*} h  vue的$createElement函数，
 * @returns 
 */
const buildColumns = function(h, vue, cols){

    let allColumns =  [
      //  {field: 'id', title:i18n.msg('ID'), minWidth: 100, sortable: true},
        {field: 'code', title:i18n.msg('订单编号'), minWidth: 130, sortable: true, 
            slots: {
                default: ({row}) => {
                    let expPkgType = row.expPkgType;
                    let code = row.code;
                    let type = dicts.stockExpPkgType.find(d => d.value === expPkgType);
                    return [
                        <span>
                            <div style="text-align:center;"><span class="id-cell"><i class="detail-cell el-icon-view"></i>{code}</span></div>
                            <div style="text-align:center;">{type?type.label:expPkgType}</div>
                            <div style="text-align:center;">{row.created}</div>
                            <div style="text-align:center;">{row.shopDayToShip}</div>
                        </span>
                    ];
                },
            }
        },
        {field: 'productThumb', title:i18n.msg('商品图'), minWidth: 80, 
            slots: {
                default: ({row}) => {
                    let id = row.productThumb;
                    return id?[
                        <ConcurrencyImage  style="width: 60px; height: 60px" 
                            key={String(id)}
                            src={api.imgView+id} 
                            previewSrcList={[api.imgView+id]}
                            ></ConcurrencyImage>
                    ]: [id];
                },
            }
        },
        {field: 'productTitle', title:i18n.msg('商品标题'), minWidth: 160, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [
                       <el-tooltip class="item" effect="dark" content={row.productTitle} placement="top-start">
                                <div class="multi-line-ellipsis" style="padding: 6px 0px;   ">
                                <el-link onClick={()=>vue.viewLink(row)} target="_blank" style="font-size:12px;" icon='el-icon-link'></el-link>
                                {/* <el-link onClick={()=>vue.viewLink(row.productId)} target="_blank" style="font-size:12px;" icon='el-icon-link'></el-link> */}
                                <span class="auto-break">{row.productTitle}</span>    
                            </div>
                        </el-tooltip>
                    ];
                },
            },
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'productSpec', title:i18n.msg('规格'), minWidth: 100, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [
                        <el-tooltip class="item" effect="dark" content={row.productSpec} placement="top-start">
                            <div class="auto-break multi-line-ellipsis">{row.productSpec}</div>
                        </el-tooltip>
                    ];
                },
            },
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'variationSku', title:i18n.msg('货号'), minWidth: 100, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [<span class="auto-break">{row.variationSku}</span>];
                },
            },
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'sku', title:i18n.msg('SKU'), minWidth: 100, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [<span class="auto-break">{row.sku}</span>];
                },
            },
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'productQty', title:i18n.msg('数量'), minWidth: 50, sortable: true,
            slots: {
                default: ({row}) => {
                    return [
                        <div class="spec">
                            <span>{row.productQty}</span>
                            <el-link style="margin-left:5px" underline={false} type="danger" title="更新数量"
                            onClick={()=>vue.updateQty(row)}>
                                <i class="el-icon-edit"></i>
                            </el-link>
                        </div>
                    ]
                }
            }
        },
        {field: 'inventory', title:i18n.msg('库存'), minWidth: 60,  
            slots: {
                default: ({row}) => {
                    let inventory = row.inventory;
                    if(inventory){
                        const list = inventory.map(item => (
                            <div>
                                <div>
                                    <div><span style="color: #409EFF; font-weight: bold;">{(item.storeName || '默认仓')}{"【"+item.qty+" EA】"}</span></div>
                                    {
                                        Object.keys(item.qtyForCode).map(key => {
                                            return <div>{key + "【"+item.qtyForCode[key]+"】"}</div>
                                        })
                                    }
                                </div>
                            </div>
                        ));
                        return [<div>{list}</div>]
                    }else{
                        return "";
                    }
                    
                }
            }
        },
        {field: 'productPrice', title:i18n.msg('单价'), minWidth: 60, sortable: true, 
            slots: {
                default: ({row}) => {
                    return ((row.productPrice || 0)/100).toFixed(2)
                }
            }
        },
        {field: 'cost', title:i18n.msg('成本'), minWidth: 60, sortable: true, 
            slots: {
                default: ({row}) => {
                    // return ((row.cost || 0)/100).toFixed(2)
                    return [
                        <div class="spec">
                            <span>{((row.cost || 0)/100).toFixed(2)}</span>
                            <el-link style="margin-left:5px" underline={false} type="danger" title="更新成本"
                            onClick={()=>vue.updateCost(row)}>
                                <i class="el-icon-edit"></i>
                            </el-link>
                        </div>
                    ]
                }
            }
        },
        {field: 'amtOrder', title:i18n.msg('总额/预估进账'), minWidth: 60, sortable: true, 
            slots: {
                default: ({row}) => {
                    // return ((row.amtOrder || 0)/100).toFixed(2)
                    return [
                        <div style="text-align:center;">
                        {((row.amtOrder || 0)/100).toFixed(2)}
                        <br/>
                        进：{row.escrowAmount || 0}
                        </div>
                    ];
                }
            }
        },
        {field: 'detailQty', title:i18n.msg('品类'), minWidth: 50, sortable: true},
        {field: 'expCompany', title:i18n.msg('配送方式'), minWidth: 55, sortable: true, 
            slots: {
                default: ({row}) => {
                    let status = dicts.stockExpGoodType.find(d => d.value === row.goodType);
                    return [
                        <div style="text-align:center;">
                        <span style="color: #67c23a;">{row.expCompany}</span><br/>
                        {status?status.label:row.goodType}<br/>{row.transport}
                        </div>
                    ];
                }
            }
        },
        {field: 'remark1', title:i18n.msg('备注'), minWidth: 135, 
            slots: {
                default: ({row}) => {
                    return [
                        <div>
                            {row.remark1 && <span>报单：{row.remark1}<br/></span>}
                            {row.remark2 && <span>货单：{row.remark2}<br/></span>}
                            {row.shopSellerMsg && <span>卖家：{row.shopSellerMsg}<br/></span>}
                            {row.note && <span>买家：{row.note}<br/></span>}
                            <span style="font-size:12px;color:#409eff;">商家平台<br/></span>
                            <div class="spec">
                                <span style="font-size:13px;">{row.storePlatform}</span>
                                <el-link style="margin-left:3px" underline={false} type="danger" title="更新商家平台"
                                onClick={()=>vue.updateStorePlatform(row,1)}>
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                            <span style="font-size:12px;color:#409eff;">信用代码<br/></span>
                            <div class="spec">
                                <span style="font-size:13px;white-space: normal;word-wrap: break-word;word-break: break-all;">{row.creditCode}</span>
                                <el-link style="margin-left:3px" underline={false} type="danger" title="更新信用代码"
                                onClick={()=>vue.updateStorePlatform(row,2)}>
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                        </div>
                    ];
                    
                }
            }
        },
        {field: 'orderStatus', title:i18n.msg('订单状态'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    let status = row.orderStatus;
                    if(status){
                        return [
                            <el-tag type="primary">{status}</el-tag>
                        ];
                    }else{
                        return "";
                    }
                }
            },
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'status', title:i18n.msg('货态'), minWidth: 80, sortable: true, 
            slots: {
                default: ({ row }) => {
                    let status = dicts.stockStatus.find(d => d.value === row.status);
                    let pageStatus = dicts.stockExpPageStatus.find(d => d.value === row.expPageStatus);
                    return [
                        <div style="text-align:center;">
                            <div><span style="color: #409EFF; font-weight: bold;">{row.storeName}</span></div>
                            <div style="margin-top:5px;">
                                <el-button size="mini" plain style="cursor: pointer;" type={status?status.type:''}>{status?status.label:row.status}</el-button>
                            </div>
                            <div style="margin-top:5px;">
                               {pageStatus?pageStatus.label:row.expPageStatus}
                            </div>
                        </div>
                    ];
                },
            },
            filters:dicts.stockStatus.filter(s => [13,15,20,23,25,80].indexOf(s.value)>-1)
        },
        {field: 'hasLink', title:i18n.msg('链接'), minWidth: 50, sortable: true, 
            slots: {
                default: ({row}) => {
                    if(row.hasLink){
                        return [<i class="el-icon-link" icon='el-icon-link'></i>]
                    }else{
                        "";
                    }
                }
            }
        },
        {field: 'purchaseStatus', title:i18n.msg('采购状态'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    return [<el-tag type={row.purchaseStatus == 1 ? "primary":"warning"}>{row.purchaseStatus == 1? '已采购':'未采购'}</el-tag>]
                }
            },
            filters:[{label: "已采购", value: 1},{label: "未采购", value: 0}]
        },
        {field: 'purchaseCode', title:i18n.msg('采购单号'), minWidth: 110, sortable: true, 
            slots: {
                default: ({row}) => {
                    return [
                        <div>{row.purchaseCode}
                        <div style="text-align:center; color: #67c23a;">{row.purchasePlatform}</div>
                        {row.purchaseTime}
                        </div>
                    ]
                }
            }
        },
        {field: 'innerExpCode', title:i18n.msg('快递单号'), minWidth: 110, sortable: true, 
            slots: {
                default: ({row}) => {
                    return [
                    <div>
                    {row.innerExpCode?
                        (
                        <span>
                            <a target="_blank" href={'https://www.baidu.com/s?wd='+row.innerExpCode}><i class="el-icon-link"></i></a>
                            {row.innerExpCode}
                        </span>
                        )
                        :""
                    }
                    <br/>
                    <span style="color: blue;">{row.shelfCode}</span>
                    <br/>{row.upperDate}</div>
                    ]
                }
            }
        },
        {field: 'purchaseTime', title:i18n.msg('采购时间'), minWidth: 90, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
            slots: {
                default: ({ row }) => {
                    return [<span class="auto-break">{row.purchaseTime}</span>];
                },
            }
        },
        {field: 'created', title:i18n.msg('下单时间'), minWidth: 90, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
            slots: {
                default: ({ row }) => {
                    return [<span class="auto-break">{row.created}</span>];
                },
            }
        },
        {field: 'shopDayToShip', title:i18n.msg('最后出货时间'), minWidth: 90, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
            slots: {
                default: ({ row }) => {
                    return [<span class="auto-break">{row.shopDayToShip}</span>];
                },
            }
        },
        {field: 'shopName', title:i18n.msg('店铺名'), minWidth: 70, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
    ];

    let showCols = [
        {type: 'checkbox', minWidth: 60}
    ]

    if(cols && cols.length>0){
        cols.forEach(f => {
            let col = allColumns.find(c => c.field == f.field);
            if(col){
                col.minWidth = f.width;
                col.sortable = f.sortable || false;
                col.title = f.alias || f.title;

                // filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
                // filterRender:  {name: 'StockFilterContent'}

                if(f.filterType == 'search'){
                    col['filters'] = [{data:''}];
                    col['filterRender'] = {name: 'FilterInput'};
                }else if(f.filterType == 'content'){
                    col['filters'] = [{data: {vals: [], sVal: '', my: "t_stock"}}];
                    col['filterRender'] = {name: 'StockFilterContent'};
                }else if(f.filterType == 'type'){
                    col['filters'] = dicts[f.filterOptionKey];
                }else if(f.filterType == 'complex'){
                    col['filters'] = [{data: {type: 'has', isCase: false, name: ''}}];
                    col['filterRender'] = {name: 'FilterComplex'};
                }else if(f.filterType == 'date'){
                    col['filters'] = [{data: []}];
                    col['filterRender'] = {
                        name: 'ElDatePicker', 
                        props: {
                            type: 'daterange', 
                            rangeSeparator: '至', startPlaceholder: '开始日期', 
                            endPlaceholder: '结束日期'
                        }
                    };
                }else {
                    col['filters'] = null;
                    col['filterRender'] = null;
                }

                showCols.push(col);
            }
        });
    }else{
        allColumns.forEach(col => showCols.push(col));
    }
  
    return showCols;

}

const allColumns = [
    {field: 'code', title:i18n.msg('订单编号')},
    {field: 'productThumb', title:i18n.msg('商品图')},
    {field: 'productTitle', title:i18n.msg('商品标题')},
    {field: 'productSpec', title:i18n.msg('规格')},
    {field: 'variationSku', title:i18n.msg('货号')},
    {field: 'sku', title:i18n.msg('SKU') },
    {field: 'productQty', title:i18n.msg('数量')},
    {field: 'inventory', title:i18n.msg('库存')},
    {field: 'productPrice', title:i18n.msg('单价')},
    {field: 'cost', title:i18n.msg('成本')},
    {field: 'amtOrder', title:i18n.msg('总额')},
    {field: 'detailQty', title:i18n.msg('品类')},
    {field: 'expCompany', title:i18n.msg('配送方式')},
    {field: 'remark1', title:i18n.msg('备注')},
    {field: 'orderStatus', title:i18n.msg('订单状态')},
    {field: 'status', title:i18n.msg('货态')},
    {field: 'hasLink', title:i18n.msg('链接')},
    {field: 'purchaseStatus', title:i18n.msg('采购状态')},
    {field: 'purchaseCode', title:i18n.msg('采购单号')},
    {field: 'innerExpCode', title:i18n.msg('快递单号')},
    {field: 'purchaseTime', title:i18n.msg('采购时间')},
    {field: 'created', title:i18n.msg('下单时间')},
    {field: 'shopDayToShip', title:i18n.msg('最后出货时间')},
    {field: 'shopName', title:i18n.msg('店铺名')},
];

const queries = [
    {field: "code", type: "input", title: "订单编号", operator: 3},
    {field: "innerExpCode", type: "input", title: "快递单号", operator: 0},
    {field: "purchaseCode", type: "input", title: "采购单号", operator: 0},
    {field: "status", type: "selectors", title: "货态", operator: "stockStatusInOrder"},
    {field: "purchaseStatus", type: "selector", title: "采购状态", operator: "purchaseStatusInOrderQuery"},
    {field: "isExpCode", type: "selector", title: "快递", operator: "existOptions"},
    {field: "isBuyLink", type: "selector", title: "链接", operator: "existOptions"},
    {field: "expCompany", type: "selectors", title: "配送方式", operator: "expCompany"},
    {field: "productTitle", type: "input", title: "商品标题", operator: 0},
    {field: "productSpec", type: "input", title: "规格", operator: 0},
    {field: "sku", type: "input", title: "SKU", operator: 0},
    {field: "variationSku", type: "input", title: "货号", operator: 0},
    {field: "shopName", type: "input", title: "店铺名", operator: 0},
    {field: "PurchaseDate", type: "datetimerange", title: "采购时间"},
    {field: "LastDate", type: "datetimerange", title: "最后出货时间"},
    {field: "Date", type: "datetimerange", title: "下单时间"},
]

export default { 
    buildColumns: buildColumns,
    allColumns:allColumns,
    queries: queries
}
